import { supabase } from '../supabase/config';

/**
 * Service to handle stock levels and inventory tracking.
 */
export const inventoryService = {
    /**
     * Subscribes to product stock levels for a tenant.
     * Tries both the original tenantId and cleaned version for DB compatibility.
     */
    subscribeToStocks(tenantId, callback) {
        if (!tenantId) return () => {};

        // Initial fetch — try original ID first, fallback to cleaned
        const fetchStocks = async () => {
            let { data } = await supabase
                .from('product_stocks')
                .select('stocks')
                .eq('tenant_id', tenantId)
                .maybeSingle();

            // If not found and ID has prefix, try without prefix
            if (!data && tenantId.startsWith('tenant_')) {
                const cleanId = tenantId.replace(/^tenant_/, '');
                const res = await supabase
                    .from('product_stocks')
                    .select('stocks')
                    .eq('tenant_id', cleanId)
                    .maybeSingle();
                data = res.data;
            }

            callback(data?.stocks || {});
        };
        fetchStocks();

        // Real-time subscription — listen on the original ID
        const channel = supabase
            .channel('stocks-' + tenantId)
            .on(
                'postgres_changes',
                { event: '*', schema: 'public', table: 'product_stocks', filter: `tenant_id=eq.${tenantId}` },
                (payload) => {
                    const row = payload.new;
                    callback(row?.stocks || {});
                }
            )
            .subscribe();

        return () => supabase.removeChannel(channel);
    },

    /**
     * Updates and saves the current stock levels.
     */
    async saveStocks(tenantId, stocks) {
        const { error } = await supabase
            .from('product_stocks')
            .upsert({
                tenant_id: tenantId,
                stocks,
                updated_at: new Date().toISOString(),
            }, { onConflict: 'tenant_id' });

        if (error) throw error;
    }
};
